import { IconButton, Paper, Stack } from "@mui/material";
import TitleHeadSess from "../../../utils/TitleHeadSess";
import { useParams, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useApi } from "../../../utils/hooks";
import LoadingSpinner from "../../../utils/LoadingSpinner";
import { ErrorAlert } from "../../../utils";
import NewMedicalDocumentButtons from "../../utils/medicalDocument/NewButtonsForPatient";
import MedicalDocumentsHistory from "./medicalDocumentsHistory";
import { Edit } from "@mui/icons-material";
import EditPatientForm from "./EditPatientForm";
import PatientData from "./Data";

const SectionContainer = ({ children }) => {
  return (
    <Paper
    variant="outlined"
    sx={{
      p: { xs: "20px 10px", sm: "20px 40px" },
      borderRadius: 3,
    }}>
      {children}
    </Paper>
  );
};

const DatailsPatient = () => {
  const location = useLocation();
  const { id } = useParams();
  const [failed, setFailed] = useState(false);
  const api = useApi();
  const [patient, setPatient] = useState({});
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const { path, patient: statePatient } = location.state || {
    path: undefined,
    patient: undefined,
  };
  const { name, surname } = patient;

  useEffect(() => {
    if (!statePatient) {
      api
        .patientsDetails(id)
        .then((response) => {
          setPatient(response);
        })
        .tap(() => setLoading(false))
        .catch(() => {
          setLoading(false);
          setFailed(true);
        });
    } else {
      setLoading(false)
      setPatient(statePatient)
    }
  }, [statePatient]);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
  };

  const handleSuccessEdit = (response) => {
    setPatient(response);
    setIsEditing(false);
  };

  if (loading && !patient)
    return <LoadingSpinner isLoading={loading} absolute />;

  if (failed && !loading)
    return (
      <ErrorAlert
        show={failed}
        onClose={() => setFailed(false)}
        message={"El paciente no existe"}
      />
    );

  if (!loading && patient) {
    return (
      <Stack
        spacing="1rem"
        sx={{
          p: { xs: "1rem", sm: "2rem" },
          mt: { xs: "1rem" },
          width: "100%",
          overflow: "auto",
        }}
      >
        <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" spacing={2}>
          <Stack direction="row" spacing={2}>
            <TitleHeadSess
              title={"Datos del Paciente | "}
              name={surname + ", " + name}
              urlRedirect={path ? path : "/patients"}
              iconTitle={"Volver"}
            />
            {!isEditing && (
              <IconButton 
                color="primary" 
                onClick={handleEditClick}
                aria-label="Editar paciente"
                sx={{ height: 'fit-content' }}
              >
                <Edit />
              </IconButton>
            )}
          </Stack>
          <Stack direction="row">
            <NewMedicalDocumentButtons patientId={id} />
          </Stack>
        </Stack>

        <SectionContainer>
          {isEditing ? (
            <EditPatientForm 
              id={id}
              onSuccess={handleSuccessEdit}
              onCancel={handleCancelEdit}
              initialValues={patient}
            />
          ) : (
            <PatientData patient={patient} />
          )}
        </SectionContainer>

        <MedicalDocumentsHistory patient={patient} />
      </Stack>
    );
  }
};

export default DatailsPatient;
